/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertType } from './InternalApiAlertType';
import {
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeFromJSONTyped,
    InternalApiAlertTypeToJSON,
    InternalApiAlertTypeToJSONTyped,
} from './InternalApiAlertType';

/**
 * Alert status update
 * @export
 * @interface InternalApiAlertStatusUpdate
 */
export interface InternalApiAlertStatusUpdate {
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertStatusUpdate
     */
    alertId: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertStatusUpdate
     */
    status: string;
    /**
     * 
     * @type {InternalApiAlertType}
     * @memberof InternalApiAlertStatusUpdate
     */
    alertType: InternalApiAlertType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiAlertStatusUpdate
     */
    note?: string;
    /**
     * Optional draft ID to clean up after successful status change
     * @type {number}
     * @memberof InternalApiAlertStatusUpdate
     */
    draftId?: number;
}



/**
 * Check if a given object implements the InternalApiAlertStatusUpdate interface.
 */
export function instanceOfInternalApiAlertStatusUpdate(value: object): value is InternalApiAlertStatusUpdate {
    if (!('alertId' in value) || value['alertId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('alertType' in value) || value['alertType'] === undefined) return false;
    return true;
}

export function InternalApiAlertStatusUpdateFromJSON(json: any): InternalApiAlertStatusUpdate {
    return InternalApiAlertStatusUpdateFromJSONTyped(json, false);
}

export function InternalApiAlertStatusUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertStatusUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'alertId': json['alertId'],
        'status': json['status'],
        'alertType': InternalApiAlertTypeFromJSON(json['alertType']),
        'note': json['note'] == null ? undefined : json['note'],
        'draftId': json['draftId'] == null ? undefined : json['draftId'],
    };
}

export function InternalApiAlertStatusUpdateToJSON(json: any): InternalApiAlertStatusUpdate {
    return InternalApiAlertStatusUpdateToJSONTyped(json, false);
}

export function InternalApiAlertStatusUpdateToJSONTyped(value?: InternalApiAlertStatusUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alertId': value['alertId'],
        'status': value['status'],
        'alertType': InternalApiAlertTypeToJSON(value['alertType']),
        'note': value['note'],
        'draftId': value['draftId'],
    };
}

